import { flattenFoldersForPicker } from "@/lib/folders/folderTree";
import type { MailAccountSettings } from "@/lib/mail/accountSettingsPrefs";
import { findAureliaFolderForSlot } from "@/lib/mail/aureliaImapFolders";
import { navFolderSlot } from "@/lib/mail/folderNavSections";
import {
  AURELIA_SNOOZED_FOLDER,
  SNOOZED_FOLDER_LABEL,
} from "@/lib/snooze/constants";
import type { MailFolder } from "@/lib/types/mail";

export function isSnoozedVirtualFolder(name: string): boolean {
  return name === AURELIA_SNOOZED_FOLDER;
}

/** Dossier IMAP lié au rôle « En attente » (Aurelia/ prioritaire). */
export function resolveSnoozedImapFolder(
  folders: MailFolder[],
  settings?: Pick<MailAccountSettings, "folderSlotOverrides">
): string | null {
  const flat = flattenFoldersForPicker(folders);

  const isUsableHold = (name: string, label: string) => {
    const slot = navFolderSlot(name, label);
    return slot !== "inbox" && slot !== "drafts" && slot !== "sent" && slot !== "trash" && slot !== "junk";
  };

  const aurelia = findAureliaFolderForSlot(flat, "snoozed");
  if (aurelia && isUsableHold(aurelia.name, aurelia.label)) {
    return aurelia.name;
  }

  const override = settings?.folderSlotOverrides?.snoozed?.trim();
  if (override) {
    const match = flat.find((f) => f.name === override);
    if (match && isUsableHold(match.name, match.label)) {
      return override;
    }
  }

  for (const folder of flat) {
    if (navFolderSlot(folder.name, folder.label) === "snoozed" && isUsableHold(folder.name, folder.label)) {
      return folder.name;
    }
  }

  return null;
}

export function isSnoozedNavRow(folder: MailFolder): boolean {
  return (
    isSnoozedVirtualFolder(folder.name) ||
    folder.label === SNOOZED_FOLDER_LABEL ||
    navFolderSlot(folder.name, folder.label) === "snoozed"
  );
}

export function isSnoozedListFolder(
  selectedFolder: string,
  folders: MailFolder[],
  settings?: Pick<MailAccountSettings, "folderSlotOverrides">
): boolean {
  if (isSnoozedVirtualFolder(selectedFolder)) return true;
  const imap = resolveSnoozedImapFolder(folders, settings);
  return imap != null && selectedFolder === imap;
}
